import { orchestrator } from 'satcheljs';
import { createEmail } from '../actions/createEmail';
import { traceCreateEmailButtonClick } from '../utils/domainOptionTracer';
import { hideFullOptions } from 'owa-options-core';
import * as React from 'react';
import { PremiumDomainConnectSecondStep } from 'owa-domain-connect';
import store from '../store/store';
import SubscriberType from '../contracts/subscriberType';
import { showModal } from 'owa-modal';

export default orchestrator(createEmail, async function createEmail() {
    traceCreateEmailButtonClick();
    hideFullOptions();
    mountDomainConnectSecondStep();
});

function mountDomainConnectSecondStep() {
    const WrappedComponent = () => (
        <PremiumDomainConnectSecondStep
            domainName={store.domainState.domainName}
            csrfToken={null}
            mountFromDomainDashBoard={true}
            isSecondaryUser={store.subscriberType == SubscriberType.Secondary}
        />
    );
    showModal(WrappedComponent);
}
